<template>
  <section>
      <button
          class="w-full px-8 py-4 custom-green-bg-color rounded-full text-white"
          @click="openExternalLinkModal();"
      >
          Get Tickets
      </button>

      <sound-rink-external-link-modal
          v-show="showModal"
          :event-schedule="eventSchedule"
          @close="closeExternalLinkModal"
      ></sound-rink-external-link-modal>
  </section>
</template>
<script>

import SoundRinkExternalLinkModal from "./SoundRinkExternalLinkModal.vue";

export default {
    name: "sound-rink-external-modal-button",

    components: {
        "sound-rink-external-link-modal": SoundRinkExternalLinkModal,
    },
    props: {
        eventSchedule: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        showModal: false,
    }),
    methods: {
        openExternalLinkModal() {
            this.showModal = true;
        },
        closeExternalLinkModal() {
            this.showModal = false;
        },
    },
};

</script>



// WEBPACK FOOTER //
// resources/js/components/SoundRinkExternalModalButton.vue